import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    // The Portal admin's live preview: the shell and screens rendered from a draft that
    // Pathway posts into the frame, with no BFF behind them (ADR-0024).
    path: 'preview',
    loadChildren: () => import('@jump-tech-frontend/portal').then(m => m.previewRoutes)
  },
  {
    path: '',
    loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.MainComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',
        loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.HomeComponent)
      },
      {
        path: 'messages',
        loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.MessagesComponent)
      },
      {
        path: 'survey',
        // Children rather than a component: the survey lib owns what its route needs
        // (a resolver that waits for the bootstrap payload), and this file stays free of
        // static lib imports so every lib remains a lazy chunk.
        loadChildren: () => import('@jump-tech-frontend/portal-relay-host').then(m => m.surveyRoutes)
      }
      // Additional Info (`additional-info`, `additional-info/:itemKey`) is deferred until it is
      // wired to real requests; its components stay in the portal lib.
    ]
  }
];
